import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Button } from 'reactstrap';
import { Loading } from '../../components/Loading';
import { getCustomGames, deleteCustomGame } from '../../services/api';

export function CustomGameList() {
    const [games, setGames] = useState([]);
    const [loading, setLoading] = useState(true);
    const history = useHistory();

    const loadGames = async () => {
        setLoading(true);
        const data = await getCustomGames();
        setGames(data);
        setLoading(false);
    };

    useEffect(() => {
        loadGames();
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm('¿Seguro que quieres eliminar este partido?')) {
            await deleteCustomGame(id);
            await loadGames();
        }
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <Container>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <h2>Partidos</h2>
                <Button color="primary" onClick={() => history.push('/customgames/new')}>Nuevo</Button>
            </div>
            {games.length === 0 ? (
                <p>No hay partidos para mostrar.</p>
            ) : (
                <div>
                    {games.map(game => (
                        <div key={game.id} style={{ border: '1px solid #dee2e6', borderRadius: '0.5rem', padding: '0.75rem 1rem', marginBottom: '0.75rem', background: '#fff' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.25rem' }}>
                                <strong style={{ fontSize: '1rem' }}>{game.name1} vs {game.name2}</strong>
                                <span style={{ fontSize: '0.85rem', color: '#6c757d', whiteSpace: 'nowrap', marginLeft: '0.5rem' }}>
                                    {game.date ? `${game.date.substring(0, 5)} ${game.date.substring(13)}` : '-'}
                                </span>
                            </div>
                            <div style={{ display: 'flex', gap: '1rem', fontSize: '0.875rem', color: '#495057', marginBottom: '0.5rem' }}>
                                <span>{game.category}</span>
                                <span>{game.score1 != null && game.score2 != null ? `${game.score1} - ${game.score2}` : '-'}</span>
                                <span>{game.status}</span>
                            </div>
                            <div style={{ display: 'flex', gap: '0.5rem' }}>
                                <Button color="secondary" size="sm" onClick={() => history.push(`/customgames/${game.id}`)}>Editar</Button>
                                <Button color="danger" size="sm" onClick={() => handleDelete(game.id)}>Eliminar</Button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </Container>
    );
}
